import { enableProdMode, ErrorHandler, provideAppInitializer, inject, provideZoneChangeDetection } from '@angular/core'
import { environment } from '@env/environment'
import { TranslateService, provideTranslateService } from '@ngx-translate/core'
import { AuthService } from '@app/services/auth/auth.service'
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http'
import { bootstrapApplication } from '@angular/platform-browser'
import { AppComponent } from '@app/app.component'
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router'
import { appRoutes } from '@app/app.routes'
import Bugsnag from '@bugsnag/js'
import packageJson from '../package.json'
import { Environment } from '@env/types'
import { BugsnagErrorHandler } from '@bugsnag/plugin-angular'
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader'
import { provideGraphQL } from '@app/modules/grapqhl/graphql.provider'
import { firstValueFrom } from 'rxjs'

if (environment.productionMode) {
    enableProdMode()
}

Bugsnag.start({
    apiKey: '71135c9c4e41b804738f6f255485f0cc',
    releaseStage: environment.name,
    appVersion: packageJson.version,
    redactedKeys: ['code', 'password'],
    enabledReleaseStages: [
        Environment.Acceptance,
        Environment.Production,
    ],
})

export function errorHandlerFactory(): ErrorHandler {
    return new BugsnagErrorHandler()
}

bootstrapApplication(AppComponent, {
    providers: [
        provideZoneChangeDetection(),
        provideGraphQL(),
        provideTranslateService({
            loader: provideTranslateHttpLoader({
                prefix: './assets/i18n/',
                suffix: '.json',
            }),
            fallbackLang: 'en',
            lang: 'en',
        }),
        {
            provide: ErrorHandler,
            useFactory: errorHandlerFactory,
        },
        provideRouter(
            appRoutes,
            withComponentInputBinding(),
            withInMemoryScrolling({
                scrollPositionRestoration: 'enabled',
            }),
        ),
        provideAppInitializer(() => {
            const translateService = inject(TranslateService)
            const authService = inject(AuthService)
            return firstValueFrom(translateService.setFallbackLang('en')).then(() => authService.initialize())
        }),
        provideHttpClient(withXhr(), withInterceptorsFromDi()),
    ],
})
    .catch(err => console.error(err))
